import React from 'react';
import './LicenceIdCard.scss';
import { DEFAULT_PHOTO_PATH } from '../../Containers/Pages/Profile/ProfilePhoto/ProfilePhotoEditorConstants';

const MiniLicenceCard = ({ discipline }) => {
   return (
      <div className={`mini-licence-tile ${discipline.toLowerCase()}-tile`}>
         <img
            src={`/images/icon-${discipline.toLowerCase()}-white.svg`}
            alt={`${discipline.toLowerCase()}-icon`}
            className="mini-card-icons"
         />
         <div className="mini-icon-text">{discipline}</div>
      </div>
   );
};

const LicenceCardBack = ({ details }) => {
   const miniCards = [];

   const plumberDisc = details.Trades.find(e => e && e.description && e.description.includes('Plumb'));
   if (plumberDisc) miniCards.push(<MiniLicenceCard discipline="Plumber" />);

   const gasfitterDisc = details.Trades.find(e => e && e.description && e.description.includes('Gas'));
   if (gasfitterDisc) miniCards.push(<MiniLicenceCard discipline="Gasfitter" />);

   const drainlayerDisc = details.Trades.find(e => e && e.description && e.description.includes('Drain'));
   if (drainlayerDisc) miniCards.push(<MiniLicenceCard discipline="Drainlayer" />);

   const allItems = [
      ...details.Trades,
      ...(details.Endorsements || []),
   ];

   const returnFirstName = () => {
      let firstName = details && details.FirstName ? details.FirstName.trim().toUpperCase() : '';
      return firstName.length > 22 ? firstName.slice(0, 22) : firstName;
   };

   const returnLastName = () => {
      let lastName = details && details.LastName ? details.LastName.trim().toUpperCase() : '';
      return lastName.length > 22 ? lastName.slice(0, 22) : lastName;
   };

   return (
      <div className="canvas-card card-back">
         <div className="detail-wrapper">
            <div className="photoContainer">
               <img
                  src={details.Image ? details.Image : DEFAULT_PHOTO_PATH}
                  alt="card-profile"
                  className="card-profile-photo"
               />
               {!details.Image && (
                  <div className="no-photo-supplied">
                     NO
                     <br />
                     PHOTO
                     <br />
                     SUPPLIED
                  </div>
               )}
               <p className="photo-licence-number">
                  {details.Barcode.toString().padStart(5, 0)}
               </p>
            </div>
            <div className="details-container">
               <div className="name-container">
                  <p className="card-firstname">{returnFirstName()}</p>
                  <p className="card-lastname">{returnLastName()}</p>
                  <div className="disc-container">
                     <table className="trades-table">
                        <thead>
                           <tr>
                              <th></th>
                              <th className="expires-col-header">EXPIRES</th>
                           </tr>
                        </thead>
                        <tbody>
                           {allItems.map((item, i) => (
                              <tr key={i}>
                                 <td className="trade-title-cell">
                                    {item.description}
                                 </td>
                                 <td className="trade-expiry-cell">
                                    {item.expiryDate}
                                 </td>
                              </tr>
                           ))}
                        </tbody>
                     </table>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default LicenceCardBack;
